import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Container,
  Typography,
  Box,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useParams } from "react-router-dom";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Create_New_EC } from "./api/Create_New_EC";

const ECSignUpForm = () => {
  const { id } = useParams();

  const [EC, setEC] = useState({
    _id: id,
  });
  const [Agency, setAgency] = useState({});
  const [IP, setIP] = useState({});
  const [newEC, setnewEC] = useState({});

  console.log(newEC);

  useEffect(() => {
    if (id && id.length === 24) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        id,
        {
          "BasicInfo.First_Name": 1,
          "BasicInfo.Last_Name": 1,
          "BasicInfo.Email": 1,
          "MetaData.Agency_id": 1,
          _id: 1,
        },
        setEC
      );
    }
  }, [id]);

  useEffect(() => {
    if (
      id &&
      id.length === 24 &&
      EC &&
      EC.MetaData &&
      EC.MetaData.Agency_id &&
      EC.MetaData.Agency_id.length > 0
    ) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          "BasicInfo.Name": 1,
        },
        setAgency
      );
    }
  }, [EC]);

  useEffect(() => {
    if (
      id &&
      id.length === 24 &&
      Agency.MetaData &&
      Agency.MetaData.IP_id &&
      Agency.MetaData.IP_id.length > 0
    ) {
      Get_One_Choose_Fields_From_MongoDB(
        "Staff",
        "Users",
        Agency.MetaData.IP_id,
        {
          Username: 1,
          _id: 1,
        },
        setIP
      );
    }
  }, [Agency]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsSubmitted(true);
    Create_New_EC(newEC, EC, Agency, IP, setIsSubmitting);
  };

  // Functions for handling changes in info
  function handleInfoChange(e, nest) {
    setnewEC({
      ...newEC,
      [nest]: { ...newEC[nest], [e.target.name]: e.target.value },
    });
  }

  let fields = [
    {
      PropName: "First_Name",
      Label: "First Name",
      Nest: "BasicInfo",
      Type: "text",
      Required: true,
    },
    {
      PropName: "Last_Name",
      Label: "Last Name",
      Nest: "BasicInfo",
      Type: "text",
      Required: true,
    },
    {
      PropName: "Email",
      Label: "Email",
      Nest: "BasicInfo",
      Type: "email",
      Required: true,
    },
    {
      PropName: "Number",
      Label: "Number",
      Nest: "BasicInfo",
      Type: "number",
      Required: true,
    },
    {
      PropName: "Job_Title",
      Label: "Job Title",
      Nest: "BasicInfo",
      Type: "text",
      Required: true,
    },
    {
      PropName: "Social_Media_Contact",
      Label: "Social Media Contact",
      Nest: "BasicInfo",
      Type: "text",
      Required: false,
    },
  ];

  const isFormValid = () => {
    //make sure for every object in fields, the nested object exists in newEC and the PropName exists in the nested object. But only for required fields
    let requiredFields = fields.filter((field) => field.Required);
    return requiredFields.every((field) => {
      return (
        newEC[field.Nest] &&
        newEC[field.Nest][field.PropName] &&
        newEC[field.Nest][field.PropName].length > 0
      );
    });
  };

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
            alt="InvestIN Banner Logo"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold" }}
            style={{ textAlign: "center" }}
          >
            Referered By: {EC.BasicInfo?.First_Name || ""}{" "}
            {EC.BasicInfo?.Last_Name || ""}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "grey.700" }}
            style={{ textAlign: "center" }}
          >
            Agency: {Agency.BasicInfo?.Name || ""} in{" "}
            {Agency.BasicInfo?.Country || ""}
            <br></br>
            Your InvestIN Contact Will Be: {IP.Username || ""}
          </Typography>
        </Box>

        <hr
          style={{ backgroundColor: "grey", height: "2px", margin: "10px 0" }}
        />
        {isSubmitted ? (
          <>
            <Typography variant="h5" component="h1" gutterBottom>
              Thank you for Submitting the Form. A confirmation email will be
              sent to your provided email address. You may now close this tab,
              or return to the form to submit another registration. We will keep
              all the previous information you have entered in the form, so
              please adjust the information for the new submission as needed for
              the new colleague.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => setIsSubmitted(false)}
            >
              Return to Form
            </Button>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5" component="h1" gutterBottom>
                    Basic Info
                  </Typography>
                  {fields.map((field) => (
                    <TextField
                      key={field.PropName}
                      name={field.PropName}
                      label={field.Label}
                      variant="outlined"
                      margin="normal"
                      type={field.Type}
                      fullWidth
                      value={
                        newEC[field.Nest] && newEC[field.Nest][field.PropName]
                          ? newEC[field.Nest][field.PropName]
                          : ""
                      }
                      onChange={(e) => handleInfoChange(e, field.Nest)}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                        },
                      }}
                    />
                  ))}

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleSubmit(e)}
                    disabled={isSubmitting || !isFormValid()}
                  >
                    {isFormValid ? (
                      <>Please Compelte All Fields To Submit</>
                    ) : isSubmitting ? (
                      "Submitting..."
                    ) : (
                      "Submit"
                    )}
                  </Button>
                  <br></br>
                  <br></br>
                </Grid>
              </Grid>
            </form>
          </>
        )}
      </Container>
    </div>
  );
};

export default ECSignUpForm;
